/*
 App

 Definicja aplikacji 
 Ekran główny  - zobacz
 // https://material-ui.com/getting-started/page-layout-examples/

 Dla testów:
    - testy komponentów: w miejsce <Booking /> wstaw  <ComponentTest />
 Todo:
  - nie skończone logowanie / wylogowywanie
  
 historia: 
  04-2019 JW - start
*/

import * as React from 'react';

import { Dialog, DialogContentText, DialogContent, DialogActions, Button, DialogTitle, Typography } from '@material-ui/core';
import { Theme, withStyles, WithStyles } from '@material-ui/core/styles';
//import { AppBar, Toolbar, Typography } from '@material-ui/core';

import { Trans } from 'react-i18next';

import { connect } from 'react-redux';

import { AppState } from '../../appredux';
import classes from '*.module.css';

interface DialogProps extends WithStyles<typeof styles> {
  page?: any,
  randomNum: number,
}

interface DialogState {
    open: boolean,
    //openDoLikw: boolean
     
   }
   
class DialogError extends React.Component<DialogProps, DialogState> {
  constructor(props: DialogProps) {
    super(props, {});
    this.state = {
        open: true,
         
     }
  }

  componentDidUpdate(prevProps: DialogProps) {
    if(this.props.randomNum !== prevProps.randomNum){
        this.setState({open: true})
    }
}

  closeDialog = () => {
    this.setState({open: false}) // , openDoLikw: false
}


  //PM 2021-08-05
  render() {
    const { classes } = this.props;

    return (
      <Dialog
        //disableEscapeKeyDown
        onEscapeKeyDown={this.closeDialog}
        onBackdropClick={this.closeDialog}
        maxWidth="xs"
        open={this.state.open}
        fullWidth
        //hideBackdrop
        classes={{scrollPaper: classes.backdrop}}
      >
         

                <DialogTitle disableTypography >
                    <Typography gutterBottom variant="h6" component="h2" color="error"
                        className={`${classes.headline}`}>
                        <b style={{ textTransform: "lowercase" }}><Trans>Warning</Trans></b>
                    </Typography>
                    <hr style={{ marginTop: "10px", borderBottom: "0px" }} />
                </DialogTitle>

                <DialogContent>
                    <DialogContentText className={classes.dialogContentText} >
                        {"przepraszamy - operacja chwilowa niedostępna"}
                    </DialogContentText>
                   



                </DialogContent >
        <DialogActions >
          
            <Button onClick={() => this.closeDialog()} variant="outlined" size="small" color="primary"
              style={{ textTransform: "none", fontSize: "0.8rem" }}
            >
              <b><Trans>Back</Trans></b>
            </Button>
           
        </DialogActions>
      </Dialog>
    );
  }
}

const styles = (theme: Theme) => ({
  backdrop: {
    backgroundColor: "rgba(0, 0, 0, 0.1)"
  },
  primary: {
    color: theme.palette.primary.main
  },
  secondary: {
    color: theme.palette.secondary.main
  },
  paddingBottom0: {
    paddingBottom: 0
  },
  headline: {
    //fontFamily: "\"'Open Sans'\", sans-serif",
    lineHeight: "20px",
    //fontSize: "16px",
    //fontWeight: 600
  },
  dialogContentText: {
    display: "flex" as "flex",
    color: theme.palette.text.secondary,
    //whiteSpace: "pre" as "pre",
    fontSize: theme.typography.body1.fontSize,
    fontFamily: theme.typography.body1.fontFamily,
    fontWeight: theme.typography.body1.fontWeight,
    lineHeight: theme.typography.body1.lineHeight,
    letterSpacing: theme.typography.body1.letterSpacing,
    marginBottom: '12px'
    //fontSize: "14px"
  },
});


const mapStateToProps = (state: AppState) => ({
  page: state.pageState
});

export default connect(mapStateToProps)(withStyles(styles)(DialogError))
